import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  '@keyframes shimmer': {
    '0%': { backgroundPosition: '-200px 0' },
    '100%': { backgroundPosition: '200px 0' },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '257px',
    padding: '16px 14px',
    gap: '10px',
    boxSizing: 'border-box',
  },
  bar: {
    width: '100%',
    borderRadius: '8px',
    background: 'linear-gradient(90deg, #ffffff06 0%, #ffffff10 50%, #ffffff06 100%)',
    backgroundSize: '400px 100%',
    animation: '$shimmer 1.5s infinite ease-in-out',
  },
});

export default function CustomCircularProgress() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.bar} style={{ height: '70px' }} />
      <div className={classes.bar} style={{ height: '70px' }} />
      <div className={classes.bar} style={{ height: '70px' }} />
    </div>
  );
}
